import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 3rem;
  position: relative;
  font-weight: 600;

  margin: 0;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 100%;
  text-align: center;
  font-size: 2rem;
  position: relative;
  margin: 1rem;
`;

export const Icon = styled.img`
  height: 319px;
  width: 249px;
  position: absolute;
  bottom: 7%;
  right: 2%;
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;
